export const updateOptionLabels = (items, trueOptionLabel, falseOptionLabel) =>
  items.map(item => {
    return {
      ...item,
      alternativeLabel:
        item.label === 'true' ? trueOptionLabel : falseOptionLabel,
    }
  })
